var map = {
	"./Flag_of_Azerbaijan.svg": 2423,
	"./ONT-OIAA-logo.png": 2424,
	"./Partly-Cloudy.png": 940,
	"./americanFlag.png": 2425,
	"./feed.jpg": 2426,
	"./franceFlag.png": 2427,
	"./germanFlag.png": 2428,
	"./portugalFlag.png": 2429,
	"./russianFlag.png": 2430,
	"./spainFlag.png": 2431,
	"./todo-assignment.svg": 2432,
	"./user.svg": 962
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2422;